import React from "react";

import Button from '@material-ui/core/Button';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import parse from 'html-react-parser';
export default function ViewCategoryModal({ handleClose, open, data }) {
    console.log(data);
    return (
        <div>

            <Dialog fullWidth open={open} onClose={handleClose} aria-labelledby="form-dialog-title" maxWidth={`xs`} >
                <DialogTitle id="form-dialog-title" className="modal-title m-0">Category Details</DialogTitle>

                <DialogContent >
                    <p><strong>Name</strong> : {data.name}</p>
                    {
                        data.parent !== null && <p><strong>Parent Category</strong> : {data.parent.name}</p>
                    }
                    <p><strong>Description</strong> : {parse(data.description)}</p>

                    <Grid container spacing={1}  alignItems="center">
                         {
                            data.category_images && data.category_images.length !== 0 && data.category_images.map((item, i)=>{
                                return  <Grid item xs={4} key={i}>
                                    <div className="category-thumb">
                                       <img src={item.image_url} alt=""/>
                                    </div>
                                   
                                </Grid>
                            })
                         }
                       
                    </Grid>


                </DialogContent>
                <DialogActions>
                    <Button type="button" onClick={handleClose} variant="contained" color="primary">
                        OK
                    </Button>

                </DialogActions>

            </Dialog>
        </div>
    );
}
